import { defineStore } from "pinia";

interface State {
  imageContent: number;
  nonImageContent: number;
  tepmlateSize: number;
}

export const useTemplateSizingStore = defineStore("templateSizing", {
  state: (): State => ({
    imageContent: 0,
    nonImageContent: 0,
    tepmlateSize: 0,
  }),
});
